export default [
  {
    path: '/rights/',
    component: require('@/pages/rights/RightsPage.vue').default
  },
  {
    path: '/rights/profiles',
    component: require('@/pages/rights/RightsConfigs.vue').default
  }
]
